var _defs, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreelogo3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 571,
    zoomAndPan: "magnify",
    viewBox: "0 0 428.25 304.499999",
    height: 406,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "275b3e3eb7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 74.953125 75.609375 L 181.238281 75.609375 L 181.238281 191.492188 L 74.953125 191.492188 Z M 74.953125 75.609375 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#275b3e3eb7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00cc95",
    d: "M 134.753906 85.894531 C 130.476562 83.386719 125.703125 83.386719 121.429688 85.894531 L 90.027344 103.953125 C 85.753906 106.460938 83.496094 110.472656 83.496094 115.496094 L 83.496094 151.605469 C 83.496094 156.625 85.753906 160.636719 90.027344 163.148438 L 121.429688 181.203125 C 125.703125 183.714844 130.476562 183.714844 134.753906 181.203125 L 166.152344 163.148438 C 170.429688 160.636719 172.683594 156.625 172.683594 151.605469 L 172.683594 115.496094 C 172.683594 110.472656 170.429688 106.460938 166.152344 103.953125 Z M 170.429688 96.679688 C 177.207031 100.691406 181.226562 107.460938 181.226562 115.496094 L 181.226562 151.605469 C 181.226562 159.640625 177.207031 166.410156 170.429688 170.421875 L 139.019531 188.476562 C 132.238281 192.488281 123.941406 192.488281 117.164062 188.476562 L 85.753906 170.421875 C 78.972656 166.410156 74.953125 159.640625 74.953125 151.605469 L 74.953125 115.496094 C 74.953125 107.460938 78.972656 100.691406 85.753906 96.679688 L 117.164062 78.621094 C 123.941406 74.601562 132.238281 74.601562 139.019531 78.621094 L 170.429688 96.679688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#00cc95",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(195.72861, 177.996362)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.832031 0 L 21.644531 0 L 21.644531 -24.085938 L 34.15625 -24.085938 L 34.15625 -29.898438 L 3.320312 -29.898438 L 3.320312 -24.085938 L 15.832031 -24.085938 Z M 15.832031 0 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#00cc95",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(233.204131, 177.996362)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.320312 0 L 9.136719 0 L 9.136719 -24.085938 L 31.972656 -24.085938 L 31.972656 -29.898438 L 9.136719 -29.898438 L 3.320312 -24.085938 Z M 3.320312 0 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#00cc95",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.499627, 177.996362)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.136719 0 L 35.089844 0 L 35.089844 -5.8125 L 9.136719 -5.8125 L 9.136719 -12.042969 L 28.339844 -12.042969 L 28.339844 -17.855469 L 9.136719 -17.855469 L 9.136719 -24.085938 L 35.089844 -24.085938 L 35.089844 -29.898438 L 9.136719 -29.898438 L 3.320312 -24.085938 L 3.320312 -5.8125 Z M 9.136719 0 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#00cc95",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(306.909432, 177.996362)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.136719 0 L 35.089844 0 L 35.089844 -5.8125 L 9.136719 -5.8125 L 9.136719 -12.042969 L 28.339844 -12.042969 L 28.339844 -17.855469 L 9.136719 -17.855469 L 9.136719 -24.085938 L 35.089844 -24.085938 L 35.089844 -29.898438 L 9.136719 -29.898438 L 3.320312 -24.085938 L 3.320312 -5.8125 Z M 9.136719 0 "
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-0.000000000000001447, 8.996941, -9.367054, -0.000000000000001506, 128.005398, 137.591428)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000176033 0.000159242 L 10.152581 0.000159242 ",
    stroke: "#00cc95",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(5.907146, -6.807162, 7.074666, 6.139281, 128.034409, 160.796875)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.0000543245 0.0000603107 L 5.317042 -0.000218765 ",
    stroke: "#00cc95",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(5.739444, 6.925366, -7.212176, 5.97714, 108.438226, 152.409176)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.0000323645 0.000126439 L 3.413761 0.00000973504 ",
    stroke: "#00cc95",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreelogo3);
export default __webpack_public_path__ + "static/media/treelogo3.00a1ffdee1feb2ea26e741d475541cb7.svg";
export { ForwardRef as ReactComponent };